import request from '@/utils/request'
import {
  TSchoolForm,
  PMaterialSearch,
  PAddCourse,
  POrgTeachers,
  PCourseSearch,
  PGetCourseById,
  PUpdateCourse,
  PLessonPage,
  PGetCourseStudentPage,
  PDeleteCourseStudent,
  PGetHistoryPage,
  PQrcode,
  TAddStudent,
  PGetLessonById,
  PUpdateLesson,
  PStartLesson,
  PPushProject,
  PPushTheme,
  TLessonStudentSearch,
  PSendCommentNotify
} from '@/types/views/educational'
import { Option } from 'element-ui'
/**
 * @description: 学校详情
 */
export function getSchoolInfo(): any {
  return request('/org/getOrgInfo')
}

/**
 * @description: 机构端教材列表
 * @param {PMaterialSearch} options 参数
 */
export function getMaterial(options: PMaterialSearch): any {
  return request('/org/getMaterialByPage', options)
}

/**
 * @description: 获取所有机构端教材列表
 * @param {id} options 参数
 */
export function getAllMaterial(options: any): any {
  return request('/course/getOrgTeaChingMaterial', options, 'POST', true)
}

/**
 * @description: 新建课程
 * @param {PAddCourse} options 参数
 */
export function addCourse(options: PAddCourse): any {
  return request('/orgCourse/addCourse', options, 'POST', true)
}

/**
 * @description: 获取机构老师
 * @param {POrgTeachers} options 参数
 */
export function getTeachers(options?: POrgTeachers): any {
  return request('/org/getOrgTeachers', options)
}

/**
 * @description: 获取机构课程列表
 * @param {PCourseSearch} options 参数
 */
export function getCourseList(options: PCourseSearch): any {
  return request('/orgCourse/getCoursePage', options)
}

/**
 * @description: 获取课程详情
 * @param {PGetCourseById} options 参数
 */
export function getCourseById(options: PGetCourseById): any {
  return request('/orgCourse/getOrgCourseDetail', options)
}
/**
 * @description: 更新课程信息
 * @param {PUpdateCourse} option 参数
 */
export function updateCourse(options: PUpdateCourse): any {
  return request('/orgCourse/updateCourse', options, 'POST', true)
}

/**
 * @description: 删除课程
 * @param {PGetCourseById} options 参数
 */
export function deleteCourse(options: PGetCourseById): any {
  return request('/orgCourse/deleteCourse', options, 'POST', true)
}
/**
 * @description: 发布课程
 * @param {PGetCourseById} options 参数
 */
export function publishCourse(options: PGetCourseById): any {
  return request('/orgCourse/publishCourse', options, 'POST', true)
}
/**
 * @description: 获取课程列表
 * @param {PLessonPage} options 参数
 */
export function getLessonPage(options: PLessonPage): any {
  return request('/orgCourse/getLessonPage', options)
}

/**
 * @description: 获取课程学员列表
 * @param {PGetCourseStudentPage} options 参数
 */
export function getCourseStudentPage(options: PGetCourseStudentPage): any {
  return request('/orgCourse/getCourseUserPage', options)
}
/**
 * @description: 删除课程学员
 * @param {PDeleteCourseStudent} options 参数
 */
export function deleteCourseStudent(options: PDeleteCourseStudent): any {
  return request('/orgCourse/deleteCourseUser', options, 'POST', true)
}

/**
 * @description: 获取学员导入历史
 * @param {type} options
 * @return:
 */
export function getHistoryPage(options: PGetHistoryPage): any {
  return request('/org/getImporthistoryPage', options)
}

/**
 * @description: 获取课程二维码
 * @param {PQrcode} options 参数
 */
export function getQrcode(options: PQrcode): any {
  return request('/orgCourse/getOrgCourseAttendUrl', options)
}
/**
 * @description: 录入学员
 * @param {TAddStudent} options 参数
 */
export function addStudent(options: TAddStudent): any {
  return request('/orgCourse/addNewCourseUser', options, 'POST', true)
}

/**
 * @description: 查看课时详情
 * @param {type} options 参数
 */
export function getLessonById(options: PGetLessonById): any {
  return request('/orgCourse/getLessonById', options)
}
/**
 * @description: 更新课时详情
 * @param {PUpdateLesson} options 参数
 */
export function updateLesson(options: PUpdateLesson): any {
  return request('/orgCourse/updateLesson', options, 'post', true)
}

/**
 * @description: 开始上课
 * @param {PStartLesson}
 * @return:
 */
export function startLesson(options: PStartLesson): any {
  return request('/orgCourse/startLesson', options, 'GET', true)
}

/**
 * @description: 作品推送
 * @param {PPushProject} options 参数
 */
export function pushProject(options: PPushProject): any {
  return request('/course/sendHalfProject', options, 'get')
}

/**
 * @description: 主题包推送
 * @param {PPushTheme} options 参数
 */
export function pushTheme(options: PPushTheme): any {
  // 该接口需要传lessonId
  // return request('/course/sendThemeToUser',options)
  // 该接口需要传lessonId和themeId
  return request('/mate/sendThemetoUser', options)
}

/**
 * @description: 获取课时详情学员列表
 * @param {TLessonStudentSearch} options 参数
 * @return:
 */
export function getLessonStudentPage(options: TLessonStudentSearch): any {
  return request('/orgCourse/getOrgLessonUserPage', options)
}
/**
 * @description: 推送老师点评信息
 * @param {PSendCommentNotify} options 参数
 */
export function sendCommentNotify(options: PSendCommentNotify): any {
  return request('/userCo/sendCommentNotify', options, 'get', true)
}
/**
 * @description: 保存老师点评
 * @param {Object} options 参数
 */
export function saveComment(options: any): any {
  return request('/orgCourse/saveTeacherComment', options, 'POST', true)
}
/**
 * @description: 获取课时评论
 * @param {Object} options 参数
 */
export function getLessonComment(options: any): any {
  return request('/orgCourse/getUserLessonComments', options)
}

/**
 * @description: 获取文档列表
 * @param {Object} options 参数
 */
export function getDocPage(options: any): any {
  return request('/orgCourse/getOrgLessonDocPage', options)
}

/**
 * @description: 获取最近课时
 * @param {Object} options 参数
 * @return:
 */
export function getRecentLessons(): any {
  return request('/orgCourse/getRecentLessons')
}

/**
 * @description: 获取上课课时列表
 * @param {Object} options 参数
 */
export function getTeachingLessonPage(options: any): any {
  return request('/orgCourse/getOrgLessonPage', options)
}

/**
 * @description: 获取上课课程列表
 * @param {Object} options 参数
 */
export function getTeachingCoursePage(options: any): any {
  return request('/orgCourse/getOrgCoursePage', options)
}

